import { ISharedSnackbarData } from '../../context/user-notifications/user-notifications.model'

/**
 * Standard error toast for a failed request: names the operation, surfaces the server's
 * reason when one exists, and logs the full error so the real cause is not swallowed.
 *
 * Usage, with the snackbar function from UserNotificationsContext:
 *   .catch(err => notifyError(userNotificationsContext.openSnackbar, err, 'saving the schedule'))
 *
 * `operation` is a present-participle phrase that completes "There was an error ...",
 * e.g. 'saving the emission', 'sending the invitation'.
 */
export const notifyError = (
  openSnackbar: (details: ISharedSnackbarData) => void,
  err: unknown,
  operation: string,
): void => {
  const serverMessage = (err as { response?: { data?: { message?: unknown } } })?.response?.data?.message
  const message = typeof serverMessage === 'string' && serverMessage.trim()
    ? `There was an error ${operation}: ${serverMessage}`
    : `There was an error ${operation}, please try again`
  console.error(err)
  openSnackbar({ open: true, message, backgroundColor: 'text.primary' })
}
